var welcomemodal = {
    badge:"Marival for Agents",
    heading:"Welcome to Marival Agents",
    intro1:"Your one-stop resource to sell with confidence, earn more commissions, access exclusive rewards, and create unforgettable vacations your clients will remember for a lifetime.",
    intro2:"Whether you're booking family vacations, luxury escapes, destination weddings, group travel, or multigenerational reunions, you'll find everything you need to grow your business—from booking tools and marketing resources to expert training and dedicated support.",

    whyTitle:"Why Travel Advisors Choose Marival",

    benefit1Title:"Increase Your Earnings",
    benefit1Text:"Competitive commissions, bonus incentives and exclusive advisor rewards.",
    benefit2Title:"Delight Your Clients",
    benefit2Text:"Award-winning resorts delivering exceptional guest experiences and repeat business.",
    benefit3Title:"Book with Confidence",
    benefit3Text:"Trusted brands backed by outstanding service, strong reputations and consistent quality.",
    benefit4Title:"Everything in One Place",
    benefit4Text:"Booking engine, rewards, training, marketing resources and sales tools—all in a single portal.",
    benefit5Title:"Expert Sales Support",
    benefit5Text:"Your dedicated Business Development team is here to help you close more bookings.",
    benefit6Title:"Grow Your Business",
    benefit6Text:"More repeat clients, stronger referrals and long-term partnerships.",

    ctaText:"Continue",
    closeLabel:"Close"
}
module.exports = welcomemodal
